
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expense-management-mobile-app",
      function () {
        return require("private-next-pages/expense-management-mobile-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expense-management-mobile-app"])
      });
    }
  